export default __webpack_public_path__ + "static/media/plain-sticker-z.3bea7d2c.png";